export function formatDateString(dateStr: string): string {
  const date = new Date(dateStr);
  // Options for day, short month, and full year
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  };
  return date.toLocaleDateString('en-GB', options);
}
